import { ActorReferentialItem } from 'api/actor';
import { actorsAPI } from 'services/swagger-api';
import { AutoCompleteKey } from './AutoCompleteKey';
import { AutoCompleteItem, AutoCompleteParams, AutoCompleteResponse } from './AutoCompleteTypes';

interface AutoCompleteConfig {
  fetchFn: (params: AutoCompleteParams) => Promise<AutoCompleteResponse>;
  mapItem: (item: any) => AutoCompleteItem;
  debounceMs?: number;
  minChars?: number;
  maxResults?: number;
}

const autocompleteRegistry: Record<AutoCompleteKey, AutoCompleteConfig> = {
  [AutoCompleteKey.ProductOwner]: {
    fetchFn: async (params: AutoCompleteParams) => {
      const response = await actorsAPI.getProductOwners({
        filter: params.filter,
        skipCount: params.skipCount || 0,
        maxResultCount: params.maxResultCount || 10,
        sorting: params.sorting,
      });
      return {
        totalCount: response.totalCount,
        items: response.items,
      };
    },
    // Owners are Personnes: the id is the personId of the product commands.
    mapItem: (item: ActorReferentialItem): AutoCompleteItem => ({
      id: item.id,
      label: item.label || '',
    }),
    debounceMs: 300,
    minChars: 2,
    maxResults: 10,
  },
  // Ajoutez d'autres configurations ici
};

export const getAutoCompleteConfig = (key: AutoCompleteKey): AutoCompleteConfig => {
  const config = autocompleteRegistry[key];
  if (!config) {
    throw new Error(`No autocomplete configuration found for key: ${key}`);
  }
  return config;
};
